module.exports = __webpack_public_path__ + "static/abilia-extraimg1-min-e3ea60565287a01bd3a4d0c01dbf7314.png";